<script setup>
import { ref, onMounted } from "vue";
import { redirectBack } from "@/utils";

const props = defineProps({
  username: String,
});

let streakFireUrl =
  import.meta.env.VITE_SLATE_DOMAIN +
  "/static/media/sites/slate-com/streak-fire.93f5566.svg";

let registerUrl = import.meta.env.VITE_SLATE_DOMAIN + "/create-account";

let error = ref("");
let streak = ref(-1);

onMounted(async () => {
  if (!props.username) return;

  try {
    let res = await fetch(
      `${import.meta.env.VITE_MYSLATE_DOMAIN}/quizzes/streak/`,
      {
        credentials: "include",
      }
    );

    if (!res.ok) {
      throw new Error();
    }

    let json = await res.json();
    streak.value = json.streak;
  } catch (err) {
    console.error(err);
    error.value = "Uh oh, failed to fetch streak data";
  }
});
</script>

<template>
  <b class="streak-status slate-graf">
    <img :src="streakFireUrl" />
    <template v-if="props.username">
      <template v-if="error">
        {{ error }}
      </template>
      <template v-else-if="streak === -1">...</template>
      <template v-else-if="streak === 0">Start a new streak!</template>
      <template v-else-if="streak < 20">{{ streak }}-day streak</template>
      <template v-else-if="streak >= 20">
        You're on a roll! Your streak is {{ streak }} days long.
      </template>
    </template>
    <template v-else>
      <a
        class="slate-link"
        :href="registerUrl"
        @click="redirectBack"
        target="_top"
        >Create an account</a
      >
      to start your streak and save your game progress.
    </template>
  </b>
</template>

<style scoped>
.streak-status {
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.4em;
  justify-content: center;
}
</style>
